import { getSpace } from './getSpace';
import type { User, UserObject } from '../util/Types/User';

export type SpaceWithResolvableObjects = {
  id: string;
  objects?: ReadonlyArray<{ id: string }>;
};

async function resolveUserObjectWithBody(
  obj: Pick<UserObject, 'id'>,
  authUser: Pick<User, 'objects'> | null | undefined,
  spaces: readonly SpaceWithResolvableObjects[],
): Promise<UserObject | null> {
  const fromUser = authUser?.objects?.find((o) => o.id === obj.id);
  if (fromUser) {
    return fromUser;
  }
  const spaceId = spaces.find((s) =>
    s.objects?.some((o) => o.id === obj.id),
  )?.id;
  if (!spaceId) {
    return null;
  }
  const { data } = await getSpace({ spaceId });
  const found = data.objects?.find((o: UserObject) => o.id === obj.id);
  return found ?? null;
}

export { resolveUserObjectWithBody };
